import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { disconnectObserver, initiateNewObserver } from "../../utils";
import { WithLazy } from "../with-lazy";

var DailyMotion = /*#__PURE__*/function (_React$Component) {
  _inherits(DailyMotion, _React$Component);

  var _super = /*#__PURE__*/_createSuper(DailyMotion);

  function DailyMotion(props) {
    var _this;

    _classCallCheck(this, DailyMotion);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderVideo", function () {
      _this.setState({
        showVideo: true
      }, function () {
        _this.addScript();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "intersectionCallback", function (entries) {
      var videoInVewPort = entries === null || entries === void 0 ? void 0 : entries[0].isIntersecting;
      var player = _this.state.dmPlayer;
      if (videoInVewPort) player.play();else {
        _this.videoPausedByObserver.current = true; // before the below line fires the pause event we set the videoPausedByObserver Ref to true, this lets the pause events callback to know that the video is not click-paused by the user but paused by the intersection observer

        player.pause();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "startObserver", function () {
      var targetElement = _this.observerRef.current;

      if (_this.intersectionObserver) {
        _this.intersectionObserver.observe(targetElement);
      } else {
        _this.intersectionObserver = initiateNewObserver(targetElement, _this.intersectionCallback);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleVideoPause", function () {
      var isVideoPausedByObserver = _this.videoPausedByObserver.current;

      if (isVideoPausedByObserver) {
        _this.videoPausedByObserver.current = false; // This is a clean up to set videoPausedByObserver back to false
      } else {
        disconnectObserver(_this.intersectionObserver);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "addScript", function () {
      var _this$props$element$m = _this.props.element.metadata,
          videoId = _this$props$element$m["video-id"],
          playerId = _this$props$element$m["player-id"];
      var script = document.createElement("script");
      script.src = "https://geo.dailymotion.com/player/".concat(playerId, ".js");
      script.dataset.video = videoId;

      _this.containerRef.current.appendChild(script);

      script.onload = function () {
        window.dailymotion.createPlayer(_this.containerRef.current.id, {
          video: videoId,
          player: playerId
        }).then(function (player) {
          _this.setState({
            dmPlayer: player
          });
        })["catch"](function (e) {
          return console.error("dm--error", e);
        });
      };
    });

    _this.containerRef = /*#__PURE__*/React.createRef();
    _this.observerRef = /*#__PURE__*/React.createRef();
    _this.videoPausedByObserver = /*#__PURE__*/React.createRef(); // To check if the video is not click paused by user but paused by intersection observer, Its implemented this way because we cannot capture the click-pause event as videos are playing in iframe

    _this.state = {
      showVideo: false,
      dmPlayer: null
    };
    return _this;
  }

  _createClass(DailyMotion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.loadIframeOnClick) {
        this.addScript();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var player = this.state.dmPlayer;
      if (!player) return;
      if (!this.observerRef.current) return;
      player.on("ad_play", this.startObserver);
      player.on("ad_pause", this.handleVideoPause);
      player.on("play", this.startObserver);
      player.on("pause", this.handleVideoPause);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      disconnectObserver(this.intersectionObserver);
    }
  }, {
    key: "render",
    value: function render() {
      var videoId = this.props.element.metadata["video-id"];

      if (this.props.loadIframeOnClick) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, !this.state.showVideo && /*#__PURE__*/React.createElement("div", {
          className: "thumbnail-wrapper"
        }, /*#__PURE__*/React.createElement("button", {
          className: "dailymotion-playBtn",
          onClick: this.renderVideo,
          "aria-label": "Play Video"
        }), /*#__PURE__*/React.createElement("img", {
          className: "dailymotion-thumbnail",
          onClick: this.renderVideo,
          src: "https://www.dailymotion.com/thumbnail/video/".concat(videoId),
          alt: "daily-motion-video"
        })), this.state.showVideo && /*#__PURE__*/React.createElement("div", {
          ref: this.observerRef
        }, /*#__PURE__*/React.createElement("div", {
          className: "dailymotion-embed-wrapper dm-embed-integration",
          ref: this.containerRef,
          id: "dm-embed-container-id-".concat(videoId)
        })));
      } else if (!this.props.loadIframeOnClick) {
        return /*#__PURE__*/React.createElement("div", {
          ref: this.observerRef
        }, /*#__PURE__*/React.createElement("div", {
          className: "dailymotion-embed-wrapper dm-embed-integration",
          ref: this.containerRef,
          id: "dm-embed-container-id-".concat(videoId)
        }));
      }
    }
  }]);

  return DailyMotion;
}(React.Component);

export default function DailyMotionEmbedScript(props) {
  return /*#__PURE__*/React.createElement(WithLazy, {
    margin: "0px"
  }, function () {
    return /*#__PURE__*/React.createElement(DailyMotion, props);
  });
}